// Keep users logged in across browser restarts when "Remember me" is on.
//
// Auth lives in sessionStorage for in-tab reads; when persistence is enabled we
// mirror into localStorage so closing the browser does not force a re-login.
const KEYS = ["token", "refreshToken", "role", "employeeid", "name"];
const PERSIST_FLAG = "hrms_persist_session";
const SAVED_EMAIL_KEY = "hrms_saved_email";

export function isPersistEnabled() {
  try {
    return localStorage.getItem(PERSIST_FLAG) !== "0";
  } catch (_) {
    return true;
  }
}

/** Remember me ON → survive browser restart; OFF → sessionStorage only. */
export function setPersistEnabled(enabled) {
  try {
    localStorage.setItem(PERSIST_FLAG, enabled ? "1" : "0");
    if (!enabled) clearPersistedAuth();
  } catch (_) { /* ignore */ }
}

export function getSavedEmail() {
  try {
    return localStorage.getItem(SAVED_EMAIL_KEY) || "";
  } catch (_) {
    return "";
  }
}

export function setSavedEmail(email) {
  try {
    const v = String(email || "").trim();
    if (v) localStorage.setItem(SAVED_EMAIL_KEY, v);
    else localStorage.removeItem(SAVED_EMAIL_KEY);
  } catch (_) { /* ignore */ }
}

/** Startup: repopulate sessionStorage from the persisted copy, if present. */
export function restoreAuth() {
  try {
    if (!isPersistEnabled()) return;
    KEYS.forEach((k) => {
      if (!sessionStorage.getItem(k)) {
        const v = localStorage.getItem(k);
        if (v) sessionStorage.setItem(k, v);
      }
    });
  } catch (_) { /* storage disabled — ignore */ }
}

/** Snapshot the current session auth into localStorage (or clear it if empty). */
export function persistAuth() {
  try {
    if (!isPersistEnabled()) {
      clearPersistedAuth();
      return;
    }
    KEYS.forEach((k) => {
      const v = sessionStorage.getItem(k);
      if (v) localStorage.setItem(k, v);
      else localStorage.removeItem(k);
    });
  } catch (_) { /* ignore */ }
}

/** Logout: wipe the persisted copy so the user stays logged out. */
export function clearPersistedAuth() {
  try { KEYS.forEach((k) => localStorage.removeItem(k)); } catch (_) { /* ignore */ }
}
